import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import PublicationProduct from './PublicationProduct'

interface PublicationProductsProps {
  assignLayoutTemplatePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const PublicationProducts = (props: PublicationProductsProps) => {
  const { assignLayoutTemplatePermissionsPayload } = props

  return (
    <DashboardModule title="Publication Products">
      <Box flexDirection="column" padding="large">
        <EntityFilters assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload} />

        <EntityList
          assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload}
          entityKey="publicationProductIds"
          entityListItemComponent={PublicationProduct}
        />
      </Box>
    </DashboardModule>
  )
}

export default PublicationProducts
